<template>
    <div>
        <div class="bg-f6f7fa">
            <div class="flex pl-24 sm:pl-32 pt-8 pb-4">
                <h3>TITLE</h3>
                <h3 class="ml-8 sm:ml-50p xl:ml-68p">QUESTION TYPE</h3>
            </div>
            <div class="bg-white flex flex-col sm:flex-row ml-16 sm:ml-8 mr-8">
                <div class="border p-8">
                    <h3>Q1</h3>
                </div>
                <div class="border flex items-center pl-4 pr-8">
                    <div>
                        <h3>How did you learn about this event?</h3>
                    </div>
                    <div class="sm:ml-32 xl:ml-40rem mr-4">
                        <h3>Multiple Choice</h3>
                    </div>
                </div>
                <div class="border flex items-center p-8 pr-20">
                    <i class="fa-solid fa-pen"></i>
                    <i class="fa-solid fa-circle-plus"></i>
                    <i class="fa-solid fa-plus"></i>
                    <i class="fa-solid fa-trash"></i>
                </div>
            </div>
            <div class="bg-white flex mt-4 flex-col sm:flex-row ml-16 sm:ml-8 mr-8">
                <div class="border p-8">
                    <h3>Q2</h3>
                </div>
                <div class="border flex items-center pl-4 pr-8">
                    <div>
                        <h3>Will you be able to attend this event?</h3>
                    </div>
                    <div class="sm:ml-32 xl:ml-40rem mr-4">
                        <h3>Multiple Choice</h3>
                    </div>
                </div>
                <div class="border flex items-center p-8 pr-20">
                    <i class="fa-solid fa-pen"></i>
                    <i class="fa-solid fa-circle-plus"></i>
                    <i class="fa-solid fa-plus"></i>
                    <i class="fa-solid fa-trash"></i>
                </div>
            </div>
            <div class="bg-white flex mt-4 flex-col sm:flex-row ml-16 sm:ml-8 mr-8">
                <div class="border p-8">
                    <h3>Q3</h3>
                </div>
                <div class="border flex items-center pl-4 pr-8">
                    <div>
                        <h3>How many guests will you be bringing to this event?</h3>
                    </div>
                    <div class="sm:ml-32 xl:ml-40rem mr-4">
                        <h3>Multiple Choice</h3>
                    </div>
                </div>
                <div class="border flex items-center p-8 pr-20">
                    <i class="fa-solid fa-pen"></i>
                    <i class="fa-solid fa-circle-plus"></i>
                    <i class="fa-solid fa-plus"></i>
                    <i class="fa-solid fa-trash"></i>
                </div>
            </div>
            <div class="bg-white flex mt-4 flex-col sm:flex-row ml-16 sm:ml-8 mr-8">
                <div class="border p-8">
                    <h3>Q4</h3>
                </div>
                <div class="border flex items-center pl-4 pr-8">
                    <div>
                        <h3>Do you have any dietary restrictions?</h3>
                    </div>
                    <div class="sm:ml-48 xl:ml-40rem mr-4">
                        <h3>Essay</h3>
                    </div>
                </div>
                <div class="border flex items-center p-8 pr-20">
                    <i class="fa-solid fa-pen"></i>
                    <i class="fa-solid fa-circle-plus"></i>
                    <i class="fa-solid fa-plus"></i>
                    <i class="fa-solid fa-trash"></i>
                </div>
            </div>
            <div class="bg-white flex mt-4 flex-col sm:flex-row ml-16 sm:ml-8 mr-8">
                <div class="border p-8">
                    <h3>Q5</h3>
                </div>
                <div class="border flex items-center pl-4 pr-8">
                    <div>
                        <h3>Will you need any special accommodations or assistance?</h3>
                    </div>
                    <div class="sm:ml-32 xl:ml-40rem mr-4">
                        <h3>Essay</h3>
                    </div>
                </div>
                <div class="border flex items-center p-8 pr-20">
                    <i class="fa-solid fa-pen"></i>
                    <i class="fa-solid fa-circle-plus"></i>
                    <i class="fa-solid fa-plus"></i>
                    <i class="fa-solid fa-trash"></i>
                </div>
            </div>
            <div class="bg-white flex mt-4 flex-col sm:flex-row ml-16 sm:ml-8 mr-8">
                <div class="border p-8">
                    <h3>Q6</h3>
                </div>
                <div class="border flex items-center pl-4 pr-8">
                    <div>
                        <h3>What is the best way for us to contact you about this event?</h3>
                    </div>
                    <div class="sm:ml-32 xl:ml-40rem mr-4">
                        <h3>Form</h3>
                    </div>
                </div>
                <div class="border flex items-center p-8 pr-20">
                    <i class="fa-solid fa-pen"></i>
                    <i class="fa-solid fa-circle-plus"></i>
                    <i class="fa-solid fa-plus"></i>
                    <i class="fa-solid fa-trash"></i>
                </div>
            </div>
            <div class="border border-dotted border-gray-600 p-8 ml-32 sm:ml-64 mr-64 flex justify-center mt-4">
                <h3>New Question</h3>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        name: "WellbeingQuestions",
        data(){
            return{
                
            }
        }
    }
</script>
<style scoped>

</style>